import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { CONTACT } from '@common/constants';
import React from 'react';

import { ApplianceRepair } from '@modules/services/applianceRepair/ApplianceRepair';

const TITLE = 'Appliance Repair Experts in London | Qeeper';
const DESC = `Fridge on the fritz? Oven going nuclear? We offer reliable appliance repairs in London.  Trust us to fix any haywire household helper. Dial ${CONTACT.PHONE}`;
const URL = 'https://www.qeeper.co.uk/services/appliance-repair';

const SEO_KEYWORDS =
  'appliance repair, washing machine repairs, dishwasher repairs, oven repair, tumble dryer repair';
const ApplianceRepairPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <ApplianceRepair />
    </>
  );
};

export default ApplianceRepairPage;
